import http from "./http";
import axios from 'axios';

export const projectsService = {
  projectsTimeService,
  projectsPaymentService,
  projectsGalleryService,
  projectsPendingActionsService,
  updateDemoProdFlagsService,
  getProjectCameraService,
  getProjectCameraFeedsService,
  stopProjectCameraFeedsService
};

// Timeline Service
function projectsTimeService(id: string) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/projects/timeline/${id}`, );
}
// Payment Service
function projectsPaymentService(id: string) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/projects/payment-milestones/${id}`, );
}
// Gallery Service
function projectsGalleryService(id: string) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/projects/gallery-overview/${id}`, );
}
// Priority Actions Service
function projectsPendingActionsService(id: string) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/projects/priority-actions/${id}`, );
}
// Project update Demo/Prod modal flags
function updateDemoProdFlagsService(payload: any) {
  return http.put(`${process.env.REACT_APP_BASE_URL}/projects/${payload?.id}/status`, {
    ...payload?.data
  });
}
// get project camera list
function getProjectCameraService(id: any) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/projects/${id}/cameras?active=true`);
}

// get project camera list
function getProjectCameraFeedsService(token: any) {
  return axios.get(`${process.env.REACT_APP_CAMERA_FEED_URL}/camera/feed/?token=${token}&TTL=5`);
}

// get project camera list
function stopProjectCameraFeedsService(token: any) {
  return axios.post(`${process.env.REACT_APP_CAMERA_FEED_URL}/camera/stop/?token=${token}`);
}


 

